editCarrouselController.$inject = ['$scope', 
                                   '$translate',
                                   '$mdDialog', 
                                   'MediasFactory', 
                                   'AlertingFactory', 
                                   'elementData',
                                   'elementView',
                                   'context'];
export function editCarrouselController($scope, 
                                        $translate,
                                        $mdDialog,
                                        MediasFactory, 
                                        AlertingFactory, 
                                        elementData, 
                                        elementView,
                                        context) {
  $scope.ok = submit;
  $scope.cancel = cancel;

  init();

  function init() {
    $scope.elementData = elementData;
    $scope.elementView = elementView;

    $scope.hasAspectRatio = elementView.getConfigurationOption('carrousel-has-aspect-ratio');
    $scope.aspectRatioRequired = elementView.getConfigurationOption('carrousel-aspect-ratio-required');
    $scope.hasCardWidth = elementView.getConfigurationOption('carrousel-has-card-width');
    $scope.cardWidthRequired = elementView.getConfigurationOption('carrousel-card-width-required');
    $scope.hasImageSize = elementView.getConfigurationOption('carrousel-has-image-size');
    $scope.imageSizeRequired = elementView.getConfigurationOption('carrousel-image-size-required');
    $scope.hasAltText = elementView.getConfigurationOption('carrousel-has-alt-text')

    initAspectRatioDropdownItems();
    initCardWidthDropdownItems();
    initImageSizeDropdownItems();
  }

  function initAspectRatioDropdownItems() {
    $scope.aspectRatioDropdownItems = [{
        id: 'horizontal', 
        label: $translate.instant(elementView.resolveTranslationKey('carrousel_edition_aspect_ratio_horizontal'))
      },{
        id: 'square', 
        label: $translate.instant(elementView.resolveTranslationKey('carrousel_edition_aspect_ratio_square'))
    }];
  }

  function initCardWidthDropdownItems() {
    $scope.cardWidthDropdownItems = [{
        id: 'small', 
        label: $translate.instant(elementView.resolveTranslationKey('carrousel_edition_card_width_small'))
      },{
        id: 'medium', 
        label: $translate.instant(elementView.resolveTranslationKey('carrousel_edition_card_width_medium'))
    }];
  }

  function initImageSizeDropdownItems() {
    $scope.imageSizeDropdownItems = [{
        id: 'cover', 
        label: $translate.instant(elementView.resolveTranslationKey('carrousel_edition_image_size_cover'))
      },{
        id: 'contain', 
        label: $translate.instant(elementView.resolveTranslationKey('carrousel_edition_image_size_contain'))
    }];
  }

  function submit() {
    $mdDialog.hide({ type: 'ok', data: $scope.elementData });
  }

  function cancel() {
    $mdDialog.cancel();
  }
}
